
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import VehicleList from "./pages/VehicleList";
import Login from "./pages/Login";
import CheckIn from "./pages/CheckIn";
import VehicleMap from "./pages/VehicleMap";
import { useToast, ToastProviderWrapper } from './components/ui/use-toast';
import { Button } from './components/ui/button';
import AddVehicle from "./pages/AddVehicle";
import MapView from "./pages/MapView";
import ChangeHistory from "./pages/ChangeHistory";
import ActivityLogs from "./pages/ActivityLogs";
import DashboardLayout from "./components/DashboardLayout";
import HomeDashboard from "./pages/HomeDashboard";
import VehicleDetailsPage from "./pages/VehicleDetailsPage";
import AddProjectPage from "./pages/AddProjectPage";
import ProjectList from "./pages/ProjectList";
import ProjectDetailsPage from "./pages/ProjectDetailsPage";
import UserManagement from "./pages/UserManagement";
import ErrorBoundary from "./components/ErrorBoundary";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <ErrorBoundary>
      <ToastProviderWrapper>
        <Router>
          <AuthProvider>
            <Routes>
              {/* Public route - show login if not authenticated, redirect to home if authenticated */}
              <Route 
                path="/login" 
                element={<Login />}
              />
              
              {/* Default route - redirect to home */}
              <Route path="/" element={<Navigate to="/home" replace />} />
              
              {/* Protected dashboard routes */}
              <Route
                path="/home"
                element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <HomeDashboard />
                    </DashboardLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/vehiclelist"
                element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <VehicleList />
                    </DashboardLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/add-vehicle"
                element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <AddVehicle />
                    </DashboardLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/add-project"
                element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <AddProjectPage />
                    </DashboardLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projects"
                element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <ProjectList />
                    </DashboardLayout>
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/project/:projectId" 
                element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <ProjectDetailsPage />
                    </DashboardLayout>
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/mapview"
                element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <MapView />
                    </DashboardLayout>
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/vehicle/:id" 
                element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <VehicleDetailsPage />
                    </DashboardLayout>
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/logs"
                element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <ChangeHistory />
                    </DashboardLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user-management"
                element={
                  <ProtectedRoute requireAdmin>
                    <DashboardLayout>
                      <UserManagement />
                    </DashboardLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/activity-logs"
                element={
                  <ProtectedRoute requireAdmin>
                    <DashboardLayout>
                      <ActivityLogs />
                    </DashboardLayout>
                  </ProtectedRoute>
                }
              />
              
              {/* Catch all route - redirect to home */}
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </AuthProvider>
        </Router>
      </ToastProviderWrapper>
    </ErrorBoundary>
  );
}

export default App;
